// @ts-expect-error RecordFactory exists
import { Map as ImmutableMap, Record } from 'immutable';
import { createContext, useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import isUndefined from 'transmute/isUndefined';
// @ts-expect-error no types
import { FOLLOW_UP, THANK_YOU } from 'feedback-schema/constants/surveyStages';
import { setFollowUp, setRating, submit, submitFollowUp } from 'feedback-public-submission-ui/actions/FeedbackResponseActions';
import { jsx as _jsx } from "react/jsx-runtime";
const SubmissionUpdatesContext = /*#__PURE__*/createContext({});
export const useSubmissionUpdates = () => useContext(SubmissionUpdatesContext);
export const SubmissionUpdatesProvider = ({
  children
}) => {
  const [contactProperties, setContactProperties] = useState(Record({})());
  const [interactionDisabled, setInteractionDisabled] = useState(false);
  const [isThankYouPreview, setIsThankYouPreview] = useState(false);
  const dispatch = useDispatch();
  const setSelectedRating = rating => dispatch(setRating(rating));
  const onFollowUpChange = e => dispatch(setFollowUp(e.target.value));
  const onRatingChange = changeStageCallback => rating => {
    setSelectedRating(rating);
    if (changeStageCallback) {
      changeStageCallback(FOLLOW_UP, rating);
    }
  };
  const onSubmit = changeStageCallback => ({
    feedbackResponse,
    params,
    surveyConfig,
    surveyType
  }) => {
    if (!params.isPreview) {
      if (surveyConfig.shouldCreatePartialSubmission) {
        dispatch(submitFollowUp(params, surveyConfig, feedbackResponse, surveyType));
      } else {
        dispatch(submit(params, surveyConfig, feedbackResponse, surveyType));
      }
    }
    if (!interactionDisabled && changeStageCallback) {
      changeStageCallback(THANK_YOU, feedbackResponse.rating);
    }
  };
  const handleInterframeMessage = updatePreview => (__messageType, InterframeProps) => {
    // This is a temporary hack until we do not migrate the editor to pass a surveyConfig
    if (InterframeProps.surveyConfig) {
      updatePreview(InterframeProps.surveyConfig);
    }
    if (!isUndefined(InterframeProps.selectedRating)) {
      setSelectedRating(InterframeProps.selectedRating);
    }
    if (!isUndefined(InterframeProps.isThankYouPreview)) {
      setIsThankYouPreview(InterframeProps.isThankYouPreview);
    }
    if (!isUndefined(InterframeProps.interactionDisabled)) {
      setInteractionDisabled(InterframeProps.interactionDisabled);
    }
    if (InterframeProps.contactProperties) {
      setContactProperties(Record(Object.assign({}, InterframeProps.contactProperties, {
        groups: ImmutableMap(InterframeProps.contactProperties.groups)
      }))());
    }
  };
  return /*#__PURE__*/_jsx(SubmissionUpdatesContext.Provider, {
    value: {
      contactProperties,
      handleInterframeMessage,
      interactionDisabled,
      isThankYouPreview,
      onFollowUpChange,
      onRatingChange,
      onSubmit,
      setInteractionDisabled,
      setSelectedRating,
      setIsThankYouPreview
    },
    children: children
  });
};